/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Overall_ProgressInputs */

const en_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Progress`)
};

const fr_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression globale`)
};

const de_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtfortschritt`)
};

const it_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso complessivo`)
};

const ru_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общий прогресс`)
};

const es_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso general`)
};

const zh_cn2_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总体进展`)
};

const ja_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全体的な進捗`)
};

const hi_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समग्र प्रगति`)
};

const pt_pt2_embed_captions_overall_progress = /** @type {(inputs: Embed_Captions_Overall_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso geral`)
};

/**
* | output |
* | --- |
* | "Overall Progress" |
*
* @param {Embed_Captions_Overall_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_overall_progress = /** @type {((inputs?: Embed_Captions_Overall_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Overall_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_overall_progress(inputs)
	if (locale === "de") return de_embed_captions_overall_progress(inputs)
	if (locale === "it") return it_embed_captions_overall_progress(inputs)
	if (locale === "ru") return ru_embed_captions_overall_progress(inputs)
	if (locale === "es") return es_embed_captions_overall_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_overall_progress(inputs)
	if (locale === "ja") return ja_embed_captions_overall_progress(inputs)
	if (locale === "hi") return hi_embed_captions_overall_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_overall_progress(inputs)
	return en_embed_captions_overall_progress(inputs)
});